<template>
  <main v-if='defaultPage.intendedTemplate == "default"'>
    <h1 v-html='defaultPage.strings.title' />
    <article v-if='defaultPage.extended'>
      <!-- Sections -->
      <blocks :content='JSON.parse(defaultPage.strings.builder)' :page='defaultPage' />
      <!-- Sections -->
      <!--<transition name='basic'>
        <keep-alive>
          <router-view id='Popup' name='popup'/>
        </keep-alive>
      </transition>-->
      <MainFooter />
    </article>
  </main>
</template>

<script>
import mixins from '.././mixins.js';

export default {
  mixins: [mixins], //kirby(), urltopath(), etc
  computed: {
    defaultPage(){
      //console.log(this.$route.params);
      if(this.kirby.pages[this.$route.params.year] && this.kirby.pages[this.$route.params.year].children) {
        let defaultPage = this.kirby.pages[this.$route.params.year].children[this.$route.params.default];
        return defaultPage;
      }
      return this.kirby.page
    }
  }
}
</script>

<style scoped>

  main {
    padding-top: 16em;
  }

  article {
    max-width: var(--main-max-width);
    padding-top: 2em;
  }

</style>

<style>

  figure div.round {
    text-align: center;
    margin-top: 3em;
    margin-bottom: 3em;
  }


  figure div.round img {
    object-fit: cover;
    width: 30em;
    height: 30em;
    border-radius: 50%;
  }

  main#Popup {
    position: fixed;
    z-index: var(--overlayz);
    background-color: rgba(255,255,255,0.95);
    margin: var(--overlaymargin);
    padding: var(--overlaypadding);
    overflow-y: scroll;
    border: var(--thinline);
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    box-sizing: border-box;
  }

  main#Popup {
    scrollbar-width: thin;
    scrollbar-color: var(--gray) var(--gray);
  }

  main#Popup::-webkit-scrollbar {
    width: 0.3rem;
  }

  main#Popup::-webkit-scrollbar-thumb {
    background-color: var(--gray);
    border-radius: 0;
  }

</style>
